import createClient from 'openapi-fetch';

const client = createClient({
    baseUrl: '/api/v1',
    credentials: 'include',
});

export async function simulateReferralProgram(payload) {
    const { data, error } = await client.POST('/super_admin/referral/simulate', {
        body: payload,
    });
    if (error) {
        const message =
            error?.detail?.[0]?.msg || error?.detail || 'خطا در محاسبه شبیه‌ساز';
        throw new Error(typeof message === 'string' ? message : JSON.stringify(message));
    }
    return data;
}

export async function compareModels(payload) {
    const { data, error } = await client.POST('/super_admin/referral/compare', {
        body: payload,
    });
    if (error) {
        const message =
            error?.detail?.[0]?.msg || error?.detail || 'خطا در مقایسه مدل‌ها';
        throw new Error(typeof message === 'string' ? message : JSON.stringify(message));
    }
    return data;
}

export async function getSuggestedCaps(marginPercent, minMarginPercent = 3) {
    const params = new URLSearchParams();
    params.set('margin_percent', String(marginPercent));
    params.set('min_margin_percent', String(minMarginPercent));

    const { data, error } = await client.GET(
        `/super_admin/referral/suggested-caps?${params}`
    );
    if (error) {
        throw new Error(error?.detail || 'خطا در دریافت پیشنهادها');
    }
    return data;
}

export async function createConfig(payload) {
    const { data, error } = await client.POST('/super_admin/referral/configs', {
        body: payload,
    });
    if (error) {
        const message =
            error?.detail?.[0]?.msg || error?.detail || 'خطا در ذخیره تنظیمات';
        throw new Error(typeof message === 'string' ? message : JSON.stringify(message));
    }
    return data;
}